/* eslint-disable functional/prefer-readonly-type */
import React, { useEffect, useState } from 'react';
import { Autocomplete, FormControl, TextField } from '@mui/material';
import { useLang } from '~/hooks/useLang';
import { useHookstate } from '@hookstate/core';
import { getContactCenter } from './services';
import { ContacteCenterResponse } from './interfaces';

interface ContactCenterProps {
    readonly onContactCenterChange: (value: number | null) => void;
    readonly contactCenterId?: number | null;
    readonly disabled?: boolean
}

export default function FilterAutocompleteContactCenter({ disabled, onContactCenterChange, contactCenterId }: ContactCenterProps) {
    const { translate } = useLang();
    const [options, setOptions] = useState<readonly ContacteCenterResponse[]>([]);
    const [value, setValue] = useState<ContacteCenterResponse | null>(null);
    const loading = useHookstate(false);

    useEffect(() => {
        getContactCenter().then(contactCenter => {
            setOptions(contactCenter)
            setValue(null)
        })
    }, [])

    useEffect(() => {
        if (!contactCenterId) {
            setValue(null)
        } else {
            setValue(options.find(opt => opt.id === contactCenterId) ?? null)
        }
    }, [contactCenterId])

    return (
        <FormControl fullWidth size='small' >
            <Autocomplete
                id='filter-agencies'
                limitTags={2}
                disabled={disabled}
                sx={{ height: 2 }}
                options={options}
                value={value}
                noOptionsText={translate('No options')}
                clearText={translate('Clear')}
                size='small'
                loading={loading.get()}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                getOptionLabel={(option) => option.name ?? ''}
                onChange={(_, type) => {
                    setValue(type)
                    onContactCenterChange(type?.id ?? null)
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={translate('Contact Center')}
                    />
                )}
            />
        </FormControl>
    )
}